export const ROYALTY_MONTHLY_SHOW_TABS = ['general', 'daily'] as const;

export type RoyaltyMonthlyShowTab = (typeof ROYALTY_MONTHLY_SHOW_TABS)[number];

export const ROYALTY_MONTHLY_DEFAULT_TAB: RoyaltyMonthlyShowTab = 'general';
